"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPackageStoreDatasheetUrl = buildPackageStoreDatasheetUrl;
function buildPackageStoreDatasheetUrl(applicationBaseUrl, packageFamilyId, packageId) {
    return `${applicationBaseUrl}/package-store/${packageFamilyId}/packages/${packageId}/datasheet`;
}
//# sourceMappingURL=package-store-datasheet-url.js.map